// Custom JS

$(document).ready(function() {

  $(window).scroll(function(){
  	var scroll = $(window).scrollTop();
	  if (scroll > 10) {
	    $(".sticky-nav").css("background" , "black");
	  }

	  else{
		  $(".sticky-nav").css("background" , "transparent");  	
	  }
  })
  
  
  	// Hide secondary price if product-prices is present
    // this function allows a price to be visible when an item is sold out **

//     if ( $('.product-prices').length > 0 ) {
//       console.log('price not needed');
//     } else {
//       $('.price.alt-price').css('display', 'block');
//     }
  
   // banner slider init on home page
   // using http://kenwheeler.github.io/slick/
  $('.banner-slider').slick({
      arrows: false,
      dots: true,
      autoplaySpeed: 5000,
      autoplay: true,
      adaptiveHeight: true,
  });
  
  
});